export default {
  disasterAuthorization: {
    title: 'Autorisation',
    text: 'Veuillez sélectionner votre fournisseur de données et entrer la clé correspondante de votre utilisateur HeiGIT Disaster Portal. Si vous n\'avez pas encore d\'utilisateur, demandez-en un en envoyant un e-mail à support[at]openrouteservice.heigit.org, en précisant votre cas d\'utilisation. Même sans clé, l\'application peut être utilisée en mode lecture seule.',
    save: 'Envoyer',
    enterTheAuthorizationKey: 'Entrez la clé ici',
    selectProvider: 'Sélectionnez votre fournisseur de données',
    useReadOnly: 'Utiliser en mode lecture',
    authenticateAsAdmin: 'Activez le mode administrateur ici',
    insertAValidKey: 'Une clé valide doit être insérée',
    insertAProvider: 'Un fournisseur de données correspondant à votre autorisation doit être choisi'
  }
}
